<div
    *ngIf="state.main_participant as main_participant"
    class="aza-section-content aza-section-colors multi-registration__main-participant {{attributeName.classNamePrefixSubParticipant}}{{
            main_participant.id
        }} {{attributeName.classNamePrefixSubParticipant}}status-{{
        main_participant.status
    }}"
>
    <div class="aza-text aza-heading">
        {{ "MAIN_PARTICIPANT" | translate }}
    </div>
    <div class="aza-form-field-area-wrapper">
        <ng-container
            *ngIf="main_participant | apply : createTicketField as field"
            [ngTemplateOutlet]="ticketFieldTemplate"
            [ngTemplateOutletContext]="{ field, participant: main_participant }"
        ></ng-container>

        {{
            main_participant.status
                | apply : recallFillElementOnStatusChanges : main_participant
        }}
    </div>
</div>

<div
    *ngIf="state.main_participant as main_participant"
    class="aza-section-content aza-section-colors {{attributeName.classNamePrefixSubParticipant}}-header"
>
    <div class="aza-text aza-heading">
        {{ "SUB_PARTICIPANTS" | translate }}
    </div>
</div>

<ng-container
    *ngFor="
        let subParticipant of state.subparticipants;
        let index = index;
        trackBy: trackByParticipant
    "
>
    <ng-container
        *ngIf="subParticipant.status !== 'CANCELLED'"
        [ngTemplateOutlet]="subParticipantTemplate"
        [ngTemplateOutletContext]="{subParticipant, index}"
    ></ng-container>
</ng-container>

<div
    class="aza-section-content aza-section-colors {{attributeName.classNamePrefixSubParticipant}}add"
>
    <div class="aza-horizontal-stack">
        <button
            class="aza-button aza-flex-grow"
            (click)="addSubParticipant()"
            [disabled]="!state.can_add_participant"
            [class.disabled]="!state.can_add_participant"
        >
            {{ "ADD_SUB_PARTICIPANT" | translate }}
        </button>
    </div>
</div>

<div
    *ngIf="state.main_participant as main_participant"
    class="aza-section-content aza-section-colors {{attributeName.classNamePrefixSubParticipant}}-header"
>
    <div class="aza-text aza-heading">
        {{ "CANCELLED_SUB_PARTICIPANTS" | translate }}
    </div>
</div>

<ng-container
    *ngFor="
        let subParticipant of state.subparticipants;
        let index = index;
        trackBy: trackByParticipant
    "
>
    <ng-container
        *ngIf="subParticipant.status === 'CANCELLED'"
        [ngTemplateOutlet]="subParticipantTemplate"
        [ngTemplateOutletContext]="{subParticipant, index}"
    ></ng-container>
</ng-container>

<ng-template
    #subParticipantTemplate
    let-subParticipant="subParticipant"
    let-index="index"
>
    <div
        class="aza-section-content aza-section-colors {{attributeName.classNamePrefixSubParticipant}}{{
            subParticipant.id
        }} {{attributeName.classNamePrefixSubParticipant}}status-{{
            subParticipant.status
        }}"
        [attr.sub-participant-id]="subParticipant.id"
    >
        <div class="aza-horizontal-stack">
            <div class="aza-flex-grow">
                <div class="aza-text aza-heading">
                    {{ "SUB_PARTICIPANT" | translate }}
                    {{ index + 1 + "" | translate }}
                    <span
                        *ngIf="
                            subParticipant.status === 'PENDING_ASSIGNMENT' ||
                            subParticipant.error?.code
                        "
                        class="aza-text-error"
                        >*</span
                    >
                </div>
                <div
                    *ngIf="subParticipant.error?.message as message"
                    class="aza-text-error"
                >
                    {{ message }}
                </div>
            </div>
            <button
                *ngIf="getFieldEditableByStatus(subParticipant.status)"
                class="aza-button"
                (click)="removeSubParticipant(subParticipant.id)"
            >
                {{ "REMOVE" | translate }}
            </button>
        </div>
        <div class="aza-form-field-area-wrapper">
            <ng-container
                *ngIf="subParticipant | apply : createTicketField as field"
                [ngTemplateOutlet]="ticketFieldTemplate"
                [ngTemplateOutletContext]="{ field, participant: subParticipant}"
            ></ng-container>
            <ng-container
                *ngFor="let field of subParticipantFields"
                [ngTemplateOutlet]="fieldTemplate"
                [ngTemplateOutletContext]="{ field, participant: subParticipant }"
            ></ng-container>
            {{
                subParticipant.status
                    | apply : recallFillElementOnStatusChanges : subParticipant
            }}
        </div>
    </div>
</ng-template>

<ng-template
    #fieldTemplate
    let-field="field"
    let-participant="participant"
    let-validateFnName="validateFnName"
>
    <div
        class="aza-form-field-area"
        [attr.aza-input-lock-value]="
            (participant.status | apply : getFieldEditableByStatus)
                ? null
                : true
        "
        [innerHtml]="
            null
                | apply
                    : createInputFieldElement
                    : field
                    : participant
                    : validateFnName
        "
    ></div>
</ng-template>

<ng-template
    #ticketFieldTemplate
    let-field="field"
    let-participant="participant"
>
    <ng-container
        *ngIf="config.multiregistration_type === 'ticket'"
        [ngTemplateOutlet]="fieldTemplate"
        [ngTemplateOutletContext]="{ field, participant, validateFnName: 'azavista.validateMultiRegistrationTicketField' }"
    ></ng-container>
</ng-template>
